import { Typography } from "@circle-react-uikit/Typography";
import { SanitizeHTMLString } from "@circle-react/components/shared/uikit/SanitizeContent";
import type { CurrentPlan } from "@circle-react/types/CurrentPlan";

import { t } from "@/i18n-js/instance";
import {
  getTierDisplayName,
  isPlanBasic,
  isPlanEnterprise,
} from "@/react/helpers/planHelpers";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";

import { WarningWrapper } from "./WarningWrapper";

export const GrandfatheredDowngradeWarning = ({
  currentPlan,
}: {
  currentPlan: CurrentPlan;
}) => {
  const { isLegacyEnterprisePlan } = usePlanStatus();

  const getDowngradeMessage = () => {
    if (isLegacyEnterprisePlan) {
      return "pricing_plans.legacy_enterprise_banner.settings";
    }

    if (
      isPlanBasic(currentPlan.tier) ||
      (isPlanEnterprise(currentPlan.tier) && !currentPlan.public)
    ) {
      return "legacy_plan_downgrade_warning";
    }

    if (currentPlan.show_pro_grandfathered_for_courses) {
      return "professional_downgrade_warning";
    }
    return "";
  };

  const downgradeMessageText = getDowngradeMessage();

  return (
    <WarningWrapper>
      <Typography.BodyMd color="text-default">
        <SanitizeHTMLString
          content={t(downgradeMessageText, {
            name: getTierDisplayName(currentPlan.tier),
            price: currentPlan.base_amount,
            interval: currentPlan.interval,
          })}
        />
      </Typography.BodyMd>
    </WarningWrapper>
  );
};
